import { type ComponentTypeNames } from '~/types/template';

import { groupComponents } from '../page-template/component-map';

export const isGroupComponent = (name: keyof ComponentTypeNames) => {
  return !!groupComponents[name];
};
